import { ShortUserListItemDto } from './userConfig'

export type NoteOverviewDto = {
    id: string
    title: string
    description?: string
    pinned: boolean
    createdByAuthor: ShortUserListItemDto
    createdAt: string
    updatedByAuthor: ShortUserListItemDto
    updatedAt: string
}

export type NoteMutationDto = {
    fileId: string
    title: string
    description?: string
}

export const mapNoteOverviewDtoToMutation = (dto: NoteOverviewDto, fileId: string): NoteMutationDto => ({
    fileId,
    title: dto.title,
    description: dto.description || undefined,
})
